// extracted by mini-css-extract-plugin
module.exports = {"title":"InactiveScreen_title__3j2Od"};